import React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import {
  Box,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Container
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import StoreIcon from '@mui/icons-material/Store';
import HandshakeIcon from '@mui/icons-material/Handshake';

import '../../../assets/css/pages/settings.css';

const Settings = (): JSX.Element => {
  return (
    <Container maxWidth='lg' className='settings-container'>
      <Box className='settings-header'>
        <Typography variant='h4' className='settings-title'>Settings</Typography>
        <Typography variant='body1' className='settings-subtitle'>Manage your application settings and configurations</Typography>
      </Box>
      <Grid container spacing={3} className='settings-grid'>
        <Grid size={{xs: 12, sm: 6, md: 4}}>
          <Card className='settings-card'>
            <CardActionArea component={Link} to='/marketplace-management' className='settings-card-action'>
              <CardContent className='settings-card-content'>
                <Box className='settings-card-icon'><StoreIcon /></Box>
                <Typography variant='h6' className='settings-card-title'>Marketplace Management</Typography>
                <Typography variant='body2' className='settings-card-description'>
                  Manage marketplace data, upload templates, and configure marketplace settings
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid size={{xs: 12, sm: 6, md: 4}}>
          <Card className='settings-card'>
            <CardActionArea component={Link} to='/business-record-management' className='settings-card-action'>
              <CardContent className='settings-card-content'>
                <Box className='settings-card-icon'><HandshakeIcon /></Box>
                <Typography variant='h6' className='settings-card-title'>Request Title Management</Typography>
                <Typography variant='body2' className='settings-card-description'>
                  Manage your services and work on the title experts data when you need them.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default observer(Settings);
